module.exports = __webpack_public_path__ + "img/no.935a6ca3.png";